import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "My web account settings")
  ])
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "form-group mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "If you wish to change your password, e-mail address, or security question, please do so in the corresponding boxes below.")
], -1)
const _hoisted_5 = { class: "form-group mb-4 d-flex gap-2" }
const _hoisted_6 = { class: "form-group d-flex flex-column justify-content-center gap-2 col-md-6 align-middle" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "fw-bold"
}, "Enter New Password:", -1)
const _hoisted_8 = { class: "input-group form-control d-flex justify-content-between align-items-center h-50" }
const _hoisted_9 = ["type"]
const _hoisted_10 = { class: "form-group d-flex flex-column gap-2 col-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "password_confirmation",
  class: "fw-bold"
}, "Confirm New Password:", -1)
const _hoisted_12 = { class: "input-group form-control d-flex justify-content-between align-items-center h-50" }
const _hoisted_13 = ["type"]
const _hoisted_14 = { class: "form-group mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Email Address: ", -1)
const _hoisted_16 = { class: "mx-2" }
const _hoisted_17 = { class: "form-group mb-4 d-flex gap-2" }
const _hoisted_18 = { class: "form-group d-flex flex-column gap-2 col-md-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "fw-bold"
}, "Enter New Email Address:", -1)
const _hoisted_20 = { class: "form-group d-flex flex-column gap-2 col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "email_confirmation",
  class: "fw-bold"
}, "Confirm New Email Address:", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "form-group mb-4 row d-flex flex-column align-items-end" }
const _hoisted_25 = { class: "col-md-1" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_SecurityQuestionSelect = _resolveComponent("SecurityQuestionSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Alerts, {
      success: $setup.success,
      errors: $setup.errors
    }, null, 8, ["success", "errors"]),
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.updateSettings && $setup.updateSettings(...args)), ["prevent"]))
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event)),
                  class: "input-password reset",
                  type: $setup.showPassword ? 'text' : 'password',
                  name: "password",
                  id: "password"
                }, null, 8, _hoisted_9), [
                  [_vModelDynamic, $setup.password]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.togglePassword && $setup.togglePassword(...args))),
                  type: "button",
                  class: "reset"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass($setup.showPassword ? 'fas fa-eye-slash' : 'fas fa-eye')
                  }, null, 2)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.passwordConfirmation) = $event)),
                  class: "input-password reset",
                  type: $setup.showPasswordConfirmation ? 'text' : 'password',
                  name: "password_confirmation",
                  id: "password_confirmation"
                }, null, 8, _hoisted_13), [
                  [_vModelDynamic, $setup.passwordConfirmation]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.togglePasswordConfirmation && $setup.togglePasswordConfirmation(...args))),
                  class: "reset",
                  type: "button"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass($setup.showPasswordConfirmation ? 'fas fa-eye-slash' : 'fas fa-eye')
                  }, null, 2)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString($setup.userEmail), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.email) = $event)),
                class: "form-control",
                type: "email",
                name: "email",
                id: "email"
              }, null, 512), [
                [_vModelText, $setup.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.emailConfirmation) = $event)),
                class: "form-control",
                type: "email",
                name: "email_confirmation",
                id: "email_confirmation"
              }, null, 512), [
                [_vModelText, $setup.emailConfirmation]
              ])
            ])
          ]),
          ($setup.numberOfQuestions > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.numberOfQuestions, (index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(_component_SecurityQuestionSelect, {
                      questions: $setup.availableQuestionsForSelect(`select${index}`).value,
                      userQuestion: $setup.userQuestions[index - 1],
                      label: "Security Question",
                      questionId: $setup.userQuestions[index - 1]?.ID,
                      index: index,
                      onHandleQuestion: $setup.handleQuestion,
                      resetInputs: $setup.resetInputs
                    }, null, 8, ["questions", "userQuestion", "questionId", "index", "onHandleQuestion", "resetInputs"])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_SecurityQuestionSelect, {
                  questions: $setup.securityQuestions,
                  userQuestion: $setup.userQuestions[0],
                  label: "Security Question",
                  questionId: $setup.userQuestions[0]?.ID ?? 0,
                  index: 0,
                  onHandleQuestion: $setup.handleQuestion,
                  resetInputs: $setup.resetInputs
                }, null, 8, ["questions", "userQuestion", "questionId", "onHandleQuestion", "resetInputs"])
              ])),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary",
                disabled: $setup.loadingUpdate
              }, _toDisplayString($setup.loadingUpdate ? 'Updating...' : ('Update')), 9, _hoisted_26)
            ])
          ])
        ], 32))
  ]))
}